/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DocumentItemDto } from '../models/DocumentItemDto';
import type { DownloadDocumentsRequestDto } from '../models/DownloadDocumentsRequestDto';
import type { MoveDocumentsRequest } from '../models/MoveDocumentsRequest';
import type { MoveDocumentsResultDto } from '../models/MoveDocumentsResultDto';
import type { RenameDocumentRequest } from '../models/RenameDocumentRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DocumentsService {

  /**
   * @returns DocumentItemDto OK
   * @throws ApiError
   */
  public static getDocument({
    projectKey,
    path,
    includeChildren = false,
  }: {
    projectKey: string,
    path?: string,
    includeChildren?: boolean,
  }): CancelablePromise<DocumentItemDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectKey}/documents',
      path: {
        'projectKey': projectKey,
      },
      query: {
        'path': path,
        'includeChildren': includeChildren,
      },
    });
  }

  /**
   * @returns DocumentItemDto OK
   * @throws ApiError
   */
  public static createDocument({
    projectKey,
    formData,
  }: {
    projectKey: string,
    formData?: {
      name?: string;
      path?: string;
      file?: Blob;
    },
  }): CancelablePromise<DocumentItemDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectKey}/documents',
      path: {
        'projectKey': projectKey,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns any OK
   * @throws ApiError
   */
  public static deleteDocument({
    projectKey,
    path,
  }: {
    projectKey: string,
    path?: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v2/projects/{projectKey}/documents',
      path: {
        'projectKey': projectKey,
      },
      query: {
        'path': path,
      },
    });
  }

  /**
   * @returns any OK
   * @throws ApiError
   */
  public static getDocumentContent({
    projectKey,
    path,
  }: {
    projectKey: string,
    path: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectKey}/documents/content',
      path: {
        'projectKey': projectKey,
      },
      query: {
        'path': path,
      },
    });
  }

  /**
   * @returns DocumentItemDto OK
   * @throws ApiError
   */
  public static renameDocument({
    projectKey,
    requestBody,
  }: {
    projectKey: string,
    requestBody?: RenameDocumentRequest,
  }): CancelablePromise<DocumentItemDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectKey}/documents/rename',
      path: {
        'projectKey': projectKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns MoveDocumentsResultDto OK
   * @throws ApiError
   */
  public static moveDocuments({
    projectKey,
    requestBody,
  }: {
    projectKey: string,
    requestBody?: MoveDocumentsRequest,
  }): CancelablePromise<MoveDocumentsResultDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectKey}/documents/move',
      path: {
        'projectKey': projectKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any OK
   * @throws ApiError
   */
  public static downloadDocuments({
    projectKey,
    requestBody,
  }: {
    projectKey: string,
    requestBody?: DownloadDocumentsRequestDto,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectKey}/documents/download',
      path: {
        'projectKey': projectKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

}
